export const ROUTES = {
  root: '/',
  login: '/login',
  confirmBooking: '/c',
  generalReception: '/general-reception',
  receiptBookingExit: '/receipt-booking/exit',
  generalReceptionDeskExit: '/general-reception-desk/exit',
  recordBookingWorkLog: '/record-booking-work-log',
  receiptBooking: '/receipt-booking',
  generalReceptionDesk: '/general-reception-desk',
  spDeliveryReport: '/sp/delivery-report/:deliveryReportUid',
  spDeliveryReportWork: '/sp/delivery-report/:deliveryReportUid/work',
  spDeliveryList: '/sp/delivery-report/:deliveryReportUid/list',
  spDeliveryWork: '/sp/delivery-report/:deliveryReportUid/work/:shipmentUid',
  spDeliveryWorkAttachmentPreview:
    '/sp/delivery-report/:deliveryReportUid/work/:shipmentUid/visits/:visitId/delivery-work/attachments/:attachmentId',
  spBerthManagement: '/sp/berth-management',
  sp: '/sp',
  mtenants: '/mtenants/:mid',
  notFound: '/not_found',
  forbidden: '/forbidden',
} as const

export const PREVIEW_FILE_ROUTES = {
  normal: '/file-preview',
  driver: '/file-driver-preview',
} as const
